<template>
  <div>
    <el-tree :accordion="true"
             ref="roleResourceTree"
             :check-strictly=true
             @check="nodeCheck"
             :data="treeData"
             node-key="id"
             :default-checked-keys="checkeds"
             show-checkbox
             :props="defaultProps"></el-tree>
  </div>
</template>
<script>
import * as authService from '../../../services/auth'
export default {
  name: 'ZkAuthTree',
  data () {
    let defaultProps = {
      children: 'children',
      label: (data, node) => {
        // let i18nKey = data['i18nKey']
        // if (i18nKey) {
        //   let value = this.$t(i18nKey)
        //   if (value !== i18nKey) {
        //     return value
        //   }
        // }
        return data.name
      }
    }
    return {
      defaultProps,
      checkeds: this.checkedkeys,
      treeData: this.authTree
    }
  },
  props: {
    authTree: {
      type: Array,
      default: function () {
        return []
      }
    },
    checkedkeys: {
      type: Array,
      default: function () {
        return []
      }
    },
    selectRoleId: {
      type: String,
      default: ''
    }
  },
  watch: {
    authTree (val) {
      this.treeData = val
    },
    checkedkeys (val) {
      this.checkeds = val
    }
  },
  methods: {
    updateRoleResource () {
      let nodes = this.$refs.roleResourceTree.getCheckedKeys()
      let roleId = this.selectRoleId
      let params = {
        resourceIds: nodes,
        roleId: roleId
      }
      authService.updateRoleResource(params).then((data) => {
        if (data.code === '00000000') {
          this.$message.info(this.$t('role.authorizeSuccess'))
        } else {
          this.$message.warning(this.$t('role.authorizeFail'))
        }
        this.$emit('authSuces')
      }).catch(data => {
        this.$notify.warning({
          top: 150,
          title: this.$t('common.warningNotice'),
          message: data.message
        })
        this.$emit('authSuces')
      })
    },
    checkParentId (parentId) {
      if (parentId) {
        this.$refs.roleResourceTree.setChecked(parentId, true, false)
        let node = this.$refs.roleResourceTree.getNode(parentId)
        if (node.data && node.data.parentId) {
          this.checkParentId(node.data.parentId)
        }
      }
    },
    checkChild (children) {
      if (children && children.length > 0) {
        children.forEach(item => {
          this.$refs.roleResourceTree.setChecked(item.id, true, false)
          if (item.children) {
            this.checkChild(item.children)
          }
        })
      }
    },
    nodeCheck (data, obj) {
      let node = this.$refs.roleResourceTree.getNode(data.id)
      if (node && node.checked) {
        let parentId = data.parentId
        this.checkParentId(parentId)
        this.checkChild(data.children)
      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// src/cdpBase/baseComponents/authTree/src/main.vue